/* Drag-à-la-souris sur les carousels featured-collection en
   scroll natif (overflow-x:auto sous 1016px, cf. custom.css). */
(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 1015.98px)';
  var SELECTORS = [
    '.featured-collection .slider-grid__d-carousel',
    '.featured-collection .slider-grid__d-carousel-overflow'
  ].join(',');

  function enableMouseDrag(el) {
    if (el.dataset.mouseDragEnabled === '1') return;
    el.dataset.mouseDragEnabled = '1';

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    el.addEventListener('mousedown', function (e) {
      if (!matchMedia(BREAKPOINT).matches) return;
      // bouton gauche uniquement
      if (e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = el.scrollLeft;
      el.style.cursor = 'grabbing';
      el.style.userSelect = 'none';
    }, true);

    var endDrag = function () {
      if (!isDown) return;
      isDown = false;
      el.style.cursor = '';
      el.style.userSelect = '';
      // si l'utilisateur a vraiment glissé, bloque le clic suivant
      if (moved) {
        var blockClick = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          el.removeEventListener('click', blockClick, true);
        };
        el.addEventListener('click', blockClick, true);
      }
    };

    window.addEventListener('mouseup', endDrag, true);
    window.addEventListener('mouseleave', endDrag, true);

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
      e.preventDefault();
    }, true);

    // évite le drag-and-drop natif d'images
    el.addEventListener('dragstart', function (e) {
      if (matchMedia(BREAKPOINT).matches) e.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll(SELECTORS).forEach(enableMouseDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan après chaque changement DOM (sections rechargées dans Theme Editor)
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () { init(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

/* Soumission du sélecteur de devise par région.
   Le markup vit dans un <template> cloné par <float-element>, donc le
   web component <localization-selector> ne s'auto-monte pas toujours
   à temps. On gère le clic au niveau document en POSTant le form via
   fetch puis reload — guarantit la soumission quel que soit l'état
   d'upgrade du custom element. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.currency-menu-simple [data-localization-item][data-value]');
    if (!btn) return;
    var form = btn.closest('form[action*="/localization"]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var input = form.querySelector('[data-localization-input]');
    if (input) input.value = btn.dataset.value;
    var data = new FormData(form);
    fetch(form.action, {
      method: 'POST',
      body: data,
      credentials: 'same-origin'
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      window.location.reload();
    });
  }, true);
})();

